import { Box, styled } from '@mui/material';

export const NewsListWrapper = styled(Box)(({ theme }) => ({
	padding: theme.spacing(3, 2, 4),
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(2),
}));
